import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEnvelope as EmailIcon } from "@react-icons/all-files/fa/FaEnvelope";

const EnviarReporteContratoButton = ({ contractId, className, style }) => {
  const [isSending, setIsSending] = useState(false);

  const enviarReporteContrato = async () => {
    if (!contractId) {
      Swal.fire({
        icon: "error",
        title: "Contrato no disponible",
        text: "No fue posible identificar el contrato para enviar el reporte.",
      });
      return;
    }

    setIsSending(true);

    try {
      const body = JSON.stringify({ contractId });
      console.log("Enviando reporte de contrato con body:", body);

      await axios.post(
        "https://alertas.cargotronics.com/api/reportes/enviar-contrato",
        body,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );

      Swal.fire({
        icon: "success",
        title: "Reporte enviado",
        text: "El reporte del contrato fue enviado correctamente.",
      });
    } catch (error) {
      console.error("Error al enviar reporte de contrato:", error);
      Swal.fire({
        icon: "error",
        title: "No se pudo enviar el reporte",
        text: "Intenta nuevamente en unos momentos.",
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      aria-label="Enviar reporte"
      title="Enviar reporte"
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "8px", ...style }}
      onClick={enviarReporteContrato}
      disabled={isSending}
    >
      {isSending ? "Enviando..." : <><EmailIcon size={15} aria-hidden="true" /> <span>Enviar R</span></>}
    </button>
  );
};

export default EnviarReporteContratoButton;
